export const agencyPageTitleGenerator = ({
  agencyName,
  suburb,
  state,
  postCode,
}: {
  agencyName: string;
  suburb: string;
  state: string;
  postCode: string;
}): string =>
  agencyName
    ? `${agencyName} | Real Estate Agency in ${suburb}, ${state.toUpperCase()} ${postCode}`
    : '';

export const agentPageTitleGenerator = ({
  agencyName,
  state,
  name,
}: {
  agencyName: string;
  name: string;
  state: string;
}): string =>
  `${name} - Real Estate Agent at ${agencyName}, ${state.toUpperCase()}`;
